import React from "react";
import { useEffect, useState } from "react";
import {
  helloWorldContract,
  connectWallet,
  updateMessage,
  loadCurrentMessage,
  getCurrentWalletConnected,
} from "./util/interact.js";

import alchemylogo from "./0xlogo.svg";
const BigNumber = require('bignumber.js')


let newMessage = "";
var flag = false;

const HelloWorld = () => {
  //state variables
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("No connection to the network."); //default message
  const [newMessage_, setNewMessage] = useState("");
  const [price, setPrice] = useState("");

  //called only once
  useEffect(async () => {
    const message = await loadCurrentMessage();
    setMessage(message);

    addSmartContractListener();

    const {address, status} = await getCurrentWalletConnected();
    setWallet(address);
    setStatus(status);

    addWalletListener();
  }, []);

  function addSmartContractListener() { //TODO: implement
  }

  function addWalletListener() { //TODO: implement
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", connectWallet);
    }
  }

  const withdraw = async () => { 
    await helloWorldContract.methods.withdrawMoney().call();
  };

  const connectWalletPressed = async () => { //TODO: implement
      const walletResponse = await connectWallet();
      setStatus(walletResponse.status);
      setWallet(walletResponse.address);
  };

  const onUpdatePressed = async () => { //TODO: implement
    await helloWorldContract.methods.withdrawMoney().call();
    setStatus("")
    if(newMessage.length == 0){
      setStatus("Domain name cannot be empty!")
      return;
    }
    

    if(newMessage.length >=3 )
      {
        if(newMessage.substr(newMessage.length - 3) !== ".0x")
          // setNewMessage(newMessage + '.0x')
          newMessage += '.0x'
      }
    else 
        newMessage += '.0x'
    // setNewMessage(newMessage + '.0x');

    // flag = true;
    setNewMessage(newMessage)

    if(walletAddress == ""){
        setStatus("🦊 Connect to Metamask using the top right button!") 
        return;
    }
    // alert(newMessage)
    const ispsble = await helloWorldContract.methods.registryIsPossible(newMessage).call();
    if(!ispsble){
      setStatus("This domain is already registered!");
      return;
    }
    let cost = new BigNumber(1e+18)
    cost *= price;
    // alert(cost)
    await  helloWorldContract.methods
      .addNameToRegistry(newMessage)
      .send({ from: walletAddress, value: cost }, function (err, res) {
        if (err) {
          console.log("An error occured", err)
          return
        }
        console.log("Hash of the transaction: " + res)
      })
};

function onKeyEvent(e){
  // if(e.keyCode == 13)
    alert("afasdf")
}
  function onChangeFunc(e){
    setNewMessage("");
    let len = e.target.value.length;
    if(e.target.value.length >= 3 )
      if(e.target.value.substr(e.target.value.length - 3) == ".0x")
        len -= 3;
    var temp;
    if(len > 4) 
        temp = 1;
    else temp = 20 - (len - 1 ) * 5;
    
    if(temp > 20)
      temp = 20;    
    setPrice(temp);

    newMessage = e.target.value;
  }

  //the UI of our component
  return (
    <div id="container">
      <img id="logo" src={alchemylogo}></img>
      <button id="walletButton" onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
          "Connected: " +
          String(walletAddress).substring(0, 6) +
          "..." +
          String(walletAddress).substring(38)
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>

      {/* <h2 style={{ paddingTop: "50px" }}>Your One Time Purchase Customizable Web3 Username</h2> */}
      {/* <p>{message}</p> */}

      
      <div id = "searchbar">
      <h2> {newMessage_} </h2>
      <h3> Price: {price} eth</h3>
        <input
          type="text"
          placeholder="Search for your new domain"
          onChange={onChangeFunc}
          // value={newMessage}
          onkeypress={onKeyEvent}
          
        />
        <button id="publish" onClick={onUpdatePressed}>
          Confirm
        </button>
        <p id="error">{status}</p>
      </div>
    </div>
  );
};

export default HelloWorld;
